import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    font-family: 'Oswald', sans-serif;
    user-select: none;
    margin: 0;
    padding: 0;
  }

  /* Full-bleed root chain + kill any stray horizontal overflow. Without this a
     child that overruns the viewport by a few px (e.g. the react-slick card
     strip) opened a horizontal scroll gutter, showing a white strip to the right
     of the full-width map. box-sizing:border-box so any padding never widens an
     element past 100%. Percentage/viewport-relative, so it holds at every size. */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  :root {
    font-family: 'Oswald', sans-serif;
    line-height: 1.5;
    font-weight: 400;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    font-weight: 500;
    color: #646cff;
    text-decoration: inherit;
    
  }
  a:hover {
    color: #535bf2;
  }

  :focus { outline: none; }

  body {
    font-family: 'Oswald', sans-serif;
    min-width: 320px;
    min-height: 100vh;
  }

  h1 {
    font-size: 3.2em;
    line-height: 1.1;
    text-align: center;
    height: 5vh;
  }

  button {
    border-radius: 8px;
    border: 1px solid transparent;
    padding: 0.6em 1.2em;
    font-size: 1em;
    font-weight: 500;
    font-family: inherit;
    background-color: #1a1a1a;
    cursor: pointer;
    transition: border-color 0.25s;
  }
  button:hover {
    border-color: #646cff;
  }
  button:focus,
  button:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }

  @media (prefers-color-scheme: light) {
    :root {
      color: #213547;
      background-color: #ffffff;
    }
    a:hover {
      color: #747bff;
    }
    button {
      background-color: #f9f9f9;
    }
  }

  .MuiDialogTitle-root, .MuiDialogContent-root, .MuiDialogActions-root, .MuiTab-root, .MuiTypography-root {
    font-family: 'Oswald', sans-serif !important;
  }

  /* react-slick sizes .slick-track inline to fit every slide (~9292px). The real
     overflow cause is the flexbox min-width:auto trap: SliderWrapper is a flex
     item (its parent Box is display:flex), so it refuses to shrink below the
     track's intrinsic width - overflow:hidden clips paint but does NOT reset
     min-width, so the item still blows out to the viewport and opens the white
     gutter beside the map. Fix at the slick level: min-width:0 lets these shrink,
     overflow:hidden !important beats react-slick's inline styles, max-width caps
     them. The flex items themselves (SliderWrapper) also get min-width:0 in their
     component styles. slick-carousel's slick.css is intentionally NOT imported -
     it would restyle all sliders and would not fix this trap anyway. */
  .slick-slider,
  .slick-list {
    min-width: 0;
    max-width: 100%;
    overflow: hidden !important;
  }
  /* NOTE: never cap .slick-track - react-slick sets its width inline (~9292px)
     to lay slides in a row and translateX between them; max-width:100% would
     override that inline width and break sliding. The track is clipped by
     .slick-list's overflow:hidden, not shrunk. */

  .slick-dots li button:before {
    color: #c4c4c4 !important;
    opacity: 0.5;
  }

  .slick-dots li.slick-active button:before {
    color: #e5007d !important;
    opacity: 1;
  }
`;

export default GlobalStyles;
